export const DETAIL_KEYS = {
    ITEM_ID: "Item ID",
    TYPE: "Type",
    EVENT: "Event",
    DASHBAORD_ID: "Dashboard ID",
    WIDGET_ID: "Widget ID",
    OLD_VAL: "Old Value",
    NEW_VAL: "New Value",
    TYPE_SHARE: "Type of Share",
    SHARED_TO: "Shared to",
    UNSHARED_WITH: "Unshared with",
    TYPE_ROLE: "Type of role",
    SETTINGS: "Settings",
    ORDER: "Order",
    CUSTOM_SETTING: "Custom Settings",
    NEW_NAME: "New Dashboard Name",
    OLD_NAME: "Old Dashboard Name",
    NAME: "Name",
    DELETE: "Delete",
    UNSHARED: "Un-share",
    ROLE: "Role",

} as const;

export const STYLE_LABEL_MAP: Record<string, string> = {
  GroupedBarGraphical: "Grouped Bar Chart",
  BarGraphical: "Horizontal Bar Chart",
  StackedBarGraphical: "Stacked Bar Chart",
  LineGraphical: "Line Chart",
  LineAndBar: "Line and Bar Chart",
  ParallelCoordinates: "Parallel Coordinates",
  DonutGraphical: "Donut Chart",
  Tabular: "Small Table",
  PivotTabular: "Pivot Table",
  Summarizable: "Executive Summary",
  Datumizable: "Datum",
};